
import React from "react"
import { Card, Container, Row, Col, Button, Form } from "react-bootstrap"

function numberOrNull(value) {
	if (value === "" || value == null) return null
	const n = Number(value)
	return Number.isFinite(n) ? n : null
}

export default class EditCustomLineItemsView extends React.Component {
	constructor(props) {
		super(props)
    
    this.job = props.job
    this.feedlot = props.feedlot
    this.is_sent_to_portal = props.is_sent_to_portal

		this.state = {
			line_items: props.custom_line_items || [],
			submitting: false,
			response_errors: []
		}

    this.itemTypes = [
      { value: "COUNT/AUDIT", label: "COUNT/AUDIT" },
      { value: "3054", label: "SOFTWARE/HARDWARE SALES" },
      { value: "6370", label: "TRAVEL EXPENSE" },
    ]

    this.billingCodes = [
      { value: "100", label: "100" },
    ]
	}

	render() {
		try {
			const line_items = this.state.line_items || []
      if (this.is_sent_to_portal) {
        return this.cannotEditView()
      }
			return (
				<Card>
					<Card.Header>
						<Container fluid>
							<Row className="align-items-center">
								<Col>
									<h3 className="mb-0">Edit Custom Line Items</h3>
								</Col>
							</Row>
						</Container>
					</Card.Header>

					<Card.Body>
            <Container fluid>
              {/* Display Errors */}
              <Row>
                <Col xs="auto">
						      {this.renderErrors(this.state.response_errors)}
                </Col>
              </Row>
              
              {/* Line Items */}
              <Row className="align-items-center">
                <Col>
                  <h5 className="mb-0">
                    <strong>Line Items</strong>
                  </h5>
                </Col>
                <Col xs="auto">
                  <Button className="m-1" variant="success" onClick={() => this.addCustomLineItem()}>
                    <i className="fas fa-plus" />
                  </Button>
                </Col>
              </Row>

              <hr />

              {line_items.map((line_item, idx) => (
                <React.Fragment key={idx}>
                  <Row key={idx}>

                    <Col xs="auto">
                      <label className="my-0"><strong>Billing Code</strong></label>
                      <select
                        className="form-control"
                        value={line_item.billing_code ?? ""}
                        onChange={(e) => {
                          const value = e.target.value
                          this.updateLineItemField(idx, "billing_code", value)
                        }}
                      >
                        <option value={""}></option>
                        {(() => {
                          const current = line_item.billing_code
                          const hasCurrent =
                            current != null &&
                            current !== "" &&
                            this.billingCodes.some((c) => String(c.value) === String(current))
                          if (hasCurrent) return null
                          if (current == null || current === "") return null
                          return <option value={current}>Unknown ({current})</option>
                        })()}
                        {this.billingCodes.map((c) => (
                          <option key={c.value} value={c.value}>
                            {c.label}
                          </option>
                        ))}
                      </select>
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Description Prefix</strong></label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={20}
                        value={line_item.description_prefix || ""}
                        style={{ fieldSizing: "content" }}
                        onChange={(e) => {
                          var line_items = this.state.line_items.slice();
                          line_items[idx] = { ...line_items[idx], description_prefix: e.target.value };
                          this.setState({ line_items });
                        }}
                      />
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Description</strong></label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={35}
                        value={line_item.description || ""}
                        style={{ fieldSizing: "content" }}
                        onChange={(e) => {
                          var line_items = this.state.line_items.slice();
                          line_items[idx] = { ...line_items[idx], description: e.target.value };
                          this.setState({ line_items });
                        }}
                      />
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Additional Description</strong></label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={55}
                        value={line_item.add_description || ""}
                        style={{ fieldSizing: "content" }}
                        onChange={(e) => {
                          var line_items = this.state.line_items.slice();
                          line_items[idx] = { ...line_items[idx], add_description: e.target.value };
                          this.setState({ line_items });
                        }}
                      />
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Item</strong></label>
                      <select
                        className="form-control"
                        value={line_item.item ?? ""}
                        onChange={(e) => {
                          const value = e.target.value
                          this.updateLineItemField(idx, "item", value)
                        }}
                      >
                        <option value={""}></option>
                        {(() => {
                          const current = line_item.item
                          const hasCurrent = current != null && current !== "" && this.itemTypes.some((t) => String(t.value) === String(current))
                          if (hasCurrent) return null
                          if (current == null || current === "") return null
                          return <option value={current}>Unknown ({current})</option>
                        })()}
                        {this.itemTypes.map((t) => (
                          <option key={t.value} value={t.value}>
                            {t.label}
                          </option>
                        ))}
                      </select>
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Unit</strong></label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        value={line_item.unit ?? ""}
                        onChange={(e) => {
                          var line_items = this.state.line_items.slice();
                          line_items[idx] = { ...line_items[idx], unit: e.target.value };
                          this.setState({ line_items });
                        }}
                      />
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Rate</strong></label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        value={line_item.rate ?? ""}
                        onChange={(e) => {
                          var line_items = this.state.line_items.slice();
                          line_items[idx] = { ...line_items[idx], rate: e.target.value };
                          this.setState({ line_items });
                        }}
                      />
                    </Col>

                    <Col xs="auto" className="d-flex flex-column align-items-end">
                      <label className="my-0"><strong>Price</strong></label>
                      <div className="form-control-plaintext">{this.lineItemPrice(line_item).toFixed(2)}</div>
                    </Col>

                  <Col xs="auto" className="d-flex flex-column align-items-center">
                    <label className="my-0"><strong>Remove</strong></label>
                    <Button variant="danger" onClick={() => this.removeLineItem(idx)}>
                      <i className="fas fa-trash" />
                    </Button>
                  </Col>

                  </Row>

                  <hr />
                </React.Fragment>
              ))}
            </Container>
					</Card.Body>

					<Card.Footer>
						{this.renderErrors(this.state.response_errors)}
						<Button variant="success" onClick={() => this.submit()} disabled={this.state.submitting}>
							Submit
						</Button>
					</Card.Footer>
				</Card>
			)
		} catch (error) {
			console.log(error)
			Sentry.captureException(error)
			return <h3 className="text-danger">Error Loading Page. Contact Developer</h3>
		}
	}

  cannotEditView() {
    return (
      <Card>
        <Card.Header>
          <Container fluid>
            <Row className="align-items-center">
              <Col>
                <h3 className="mb-0">Edit Line Items</h3>
              </Col>
              <Col xs="auto">
                {this.job && (
                  <a className="btn btn-secondary mr-2" href={Routes.admin_job_path(this.job.id)}>
                    {this.job.name}
                  </a>
                )}
                {this.feedlot && (
                  <a className="btn btn-secondary" href={Routes.admin_feedlot_path(this.feedlot.id)}>
                    {this.feedlot.name}
                  </a>
                )}
              </Col>
            </Row>
          </Container>
        </Card.Header>

        <Card.Body>
          <h4 className="text-danger m-2">This work order has been sent to the portal and cannot be edited.</h4>
        </Card.Body>
      </Card>
    )
  }

  getCountyInfo() {
    $.ajax({
      url: Routes.counties_admin_feedlots_path(),
      type: "GET",
      dataType: "json",
      success: (response) => {
        if (response?.status === "Success") {
          this.setState({ counties: response.locations || [] })
        } else {
          this.setState({ counties: [] })
        }
      },
      error: () => {
        this.setState({ counties: [] })
      },
    })
  }

  countyFromLocationNo(location_no) {
    const county = (this.state.counties || []).find((c) => String(c.location_no) === String(location_no))
    return county ? county.location : `Unknown (${location_no})`
  }

  addCustomLineItem() {
    const items = (this.state.line_items || []).slice()
    items.push({
      billing_code: "100",
      description: "",
      description_prefix: `${this.feedlot ? this.feedlot.name : ""}`,
      add_description: "",
      item: "COUNT/AUDIT",
      rate: 0,
      unit: 1,
      location_no: this.feedlot ? this.feedlot.location_no : null,
    })
    this.setState({ line_items: items })
  }

  removeLineItem(idx) {
    const items = (this.state.line_items || []).slice()
    items.splice(idx, 1)
    this.setState({ line_items: items })
  }

	updateWorkOrderField(field, value) {
		const work_order = { ...this.state.work_order }
		work_order[field] = value
		this.setState({ work_order })
	}

	updateLineItemField(idx, field, value) {
		const items = (this.state.line_items || []).slice()
		items[idx] = { ...items[idx], [field]: value }
		this.setState({ line_items: items })
	}

	lineItemPrice(li) {
		const rate = Number(li.rate || 0)
		const unit = Number(li.unit || 0)
		if (!Number.isFinite(rate) || !Number.isFinite(unit)) return 0
		return rate * unit
	}

	renderErrors(errors) {
		if (!errors || errors.length === 0) return null
		return errors.map((e, i) => (
			<p key={i} className="text-danger my-0">
				{e}
			</p>
		))
	}

	async submit() {
		if (this.state.submitting) return

		this.setState({ submitting: true, response_errors: [] })

		const wo = this.state.work_order
		const payload = {
			line_items: (this.state.line_items || []).map((li) => ({
        id: li.id,
				billing_code: li.billing_code,
				description: li.description,
				description_prefix: li.description_prefix,
				add_description: li.add_description,
				item: li.item,
				rate: numberOrNull(li.rate),
				unit: numberOrNull(li.unit)
			})),
		}

		const path = Routes.update_custom_line_items_admin_job_path(this.job.id)
		$.ajax({
			url: path,
			method: "POST",
			dataType: "json",
			data: payload,
			success: (data) => {
        console.log("Response from server:", data)
				if (data?.status === "Success") {
          console.log(this.job.id)
					window.location = Routes.admin_job_path(this.job.id)
				} else {
          console.log("Error in response:", data)
					this.setState({ response_errors: data?.errors || ["Request Failed"], submitting: false })
				}
			},
			error: () => {
        console.log("AJAX request failed")
				this.setState({ response_errors: ["Request Failed"], submitting: false })
			},
			complete: () => {
        console.log("submitting complete")
				this.setState({ submitting: false })
			},
		})
	}
}

